import { Library } from '@/docs-partials/clips';
import * as React from 'react';
export default {
  Library,
  React
};